import React from 'react';
import { IEditorProps } from "../components/props-interfaces";
import _ from "lodash";
import { config } from "config";
import { FileType } from "data/mime-type";
import { BinaryFileEditor } from "../components/binary-file-editor";
import { ImageFileEditor } from "../components/image-file-editor";
import { InstanceFormEditor } from "../components/instance-form-editor";
import { IEditorWithCondition } from './editor-with-condition';
import { directoryEditorLister } from './directory-editor-lister';
import { ServicesEditor } from 'components/services-editor';
import { CodeEditor } from 'components/code-editor';
import { SchemaFormEditor } from 'components/schema-form-editor';
import { ZipEditor } from 'components/zip-editor';

export interface IEditorEntry {
    name: string,
    displayName: string,
    props: IEditorProps
}

export class EditorRegister {
    editors: IEditorWithCondition[] = [];

    register(name: string, displayName: string, priority: number, test: (props: IEditorProps) => boolean, editor: React.FunctionComponent<IEditorProps>) {
        this.editors.push({ name, displayName, priority, test, editor });
    }

    registerLister(name: string, test: (props: IEditorProps) => boolean, editorLister: (props: IEditorProps) => IEditorProps[]) {
        this.editors.push({ name, displayName: '', priority: 0, test, editorLister });
    }

    private getEditorListInner(props: IEditorProps): IEditorEntry[] {
        return [ props ].flatMap((props) => this.editors
            .filter(ewc => ewc.test(props))
            .flatMap(ewc => ewc.editor
                ? { name: ewc.name, displayName: ewc.displayName, priority: ewc.priority, props } as IEditorEntry
                : (ewc.editorLister
                    ? ewc.editorLister(props).flatMap(subProps => 
                        this.getEditorListInner(subProps))
                    : [])
        ));
    }

    getEditorList(props: IEditorProps): IEditorEntry[] {
        const editors = _.orderBy(this.getEditorListInner(props), [ 'priority' ], [ 'desc' ]);
        console.log('editors: ' + editors.map(val => val.name).join(', '));
        return editors;
    }

    getEditor(name: string): React.FunctionComponent<IEditorProps> | undefined {
        const editor = this.editors.find(e => e.name === name);
        return (editor && editor.editor);
    }
}

export const editorRegister: EditorRegister = new EditorRegister();

editorRegister.register("binaryFileEditor", "Editor", 0, (props) => {
    const category = config.mime.getCategory(props.mimeType);
    return category === FileType.Binary;
}, BinaryFileEditor);

editorRegister.register("zipEditor", "Zip", 30, (props) => {
    const category = config.mime.getCategory(props.mimeType);
    return category === FileType.Zip;
}, ZipEditor);

editorRegister.register("codeEditor", "Editor", 10, (props) => {
    return ([ FileType.Text, FileType.JsonInstance ].includes(config.mime.getCategory(props.mimeType)))
}, CodeEditor);

editorRegister.register("imageEditor", "Editor", 10, (props) => {
    return (config.mime.getCategory(props.mimeType) === FileType.Image)
}, ImageFileEditor);

editorRegister.register("instanceFormEditor", "Editor", 15, (props) => {
    return (config.mime.getCategory(props.mimeType) === FileType.JsonInstance)
}, InstanceFormEditor);

editorRegister.register("schemaFormEditor", "Editor", 20, (props) => {
    return props.mimeType.startsWith("application/schema+json");
}, SchemaFormEditor);

editorRegister.registerLister("directory", (props) => {
    return (config.mime.getCategory(props.mimeType) === FileType.Directory);
}, directoryEditorLister);

editorRegister.register("servicesEditor", "Services", 20, (props) => {
    return (props.service !== null && props.service.apisSupported === "services");
}, ServicesEditor);